// Game catalog + quiz definitions for Video Game Mania

export const CATEGORIES = {
  arcade: { key: "arcade", label: "Arcade", color: "#00F0FF" },
  brain: { key: "brain", label: "Brain Teaser", color: "#39FF14" },
  quiz: { key: "quiz", label: "Quiz", color: "#FF003C" },
};

export const GAMES = [
  {
    id: "snake",
    title: "Neon Snake",
    category: "arcade",
    blurb: "The timeless classic. Eat, grow, don't bite yourself.",
    image: "https://images.unsplash.com/photo-1562229125-6d6075419a22?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    type: "single",
    free: true,
  },
  {
    id: "2048",
    title: "2048 Rush",
    category: "arcade",
    blurb: "Slide tiles, combine numbers, chase that 2048 tile.",
    image: "https://images.pexels.com/photos/8108665/pexels-photo-8108665.jpeg?auto=compress&cs=tinysrgb&w=800",
    type: "single",
    free: true,
  },
  {
    id: "memory",
    title: "Memory Match",
    category: "arcade",
    blurb: "Flip cards, find pairs, beat the clock.",
    image: "https://images.unsplash.com/photo-1611996575749-79a3a250f948?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    type: "single",
    free: true,
  },
  {
    id: "simon",
    title: "Simon Says",
    category: "brain",
    blurb: "Memorize the glowing sequence. How far can your brain go?",
    image: "https://images.unsplash.com/photo-1577401239170-897942555fb3?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    type: "single",
    free: true,
  },
  {
    id: "math-blitz",
    title: "Math Blitz IQ",
    category: "brain",
    blurb: "Solve as many problems as you can in 60 seconds.",
    image: "https://images.unsplash.com/photo-1635070041078-e363dbe005cb?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    type: "single",
    free: true,
  },
  {
    id: "whack",
    title: "Alien Smash",
    category: "arcade",
    blurb: "Whack-a-mole with attitude. Smash the aliens before they hide!",
    image: "https://images.unsplash.com/photo-1614294148960-9aa740632a87?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    type: "single",
    free: true,
  },
  {
    id: "iq-test",
    title: "Pattern IQ Test",
    category: "brain",
    blurb: "10 sequence puzzles. Find the pattern and get your IQ score.",
    image: "https://images.unsplash.com/photo-1509228468518-180dd4864904?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    type: "single",
    free: true,
  },
  {
    id: "word-mania",
    title: "Word Mania",
    category: "brain",
    blurb: "Guess the hidden 5-letter word in 6 tries. Share your grid!",
    image: "https://images.unsplash.com/photo-1632501641765-e568d28b0015?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    type: "single",
    free: true,
  },
  {
    id: "tictactoe",
    title: "Tic-Tac-Toe Duel",
    category: "arcade",
    blurb: "The classic showdown. Grab a friend and battle on one screen.",
    image: "https://images.unsplash.com/photo-1611996575749-79a3a250f948?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    type: "versus",
    free: true,
  },
  {
    id: "connect-four",
    title: "Connect Four Clash",
    category: "arcade",
    blurb: "Drop, line up four, and beat your friend on one screen.",
    image: "https://images.unsplash.com/photo-1629760946220-5693ee4c46ac?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    type: "versus",
    free: true,
  },
  {
    id: "sliding-puzzle",
    title: "Slide 15 Puzzle",
    category: "brain",
    blurb: "Order the tiles 1–15 in the fewest moves. A classic brain bender.",
    image: "https://images.pexels.com/photos/163064/play-stone-network-networked-interactive-163064.jpeg?auto=compress&cs=tinysrgb&w=800",
    type: "single",
    free: true,
  },
  {
    id: "typing-test",
    title: "Typing Speed Test",
    category: "brain",
    blurb: "How fast can you type? Measure your WPM and accuracy.",
    image: "https://images.pexels.com/photos/5380584/pexels-photo-5380584.jpeg?auto=compress&cs=tinysrgb&w=800",
    type: "single",
    free: true,
  },
  {
    id: "reaction-time",
    title: "Reflex Reaction Test",
    category: "brain",
    blurb: "Click the instant it turns green. Test your reaction time over 5 trials.",
    image: "https://images.unsplash.com/photo-1538113300105-e51e4560b4aa?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    type: "single",
    free: true,
  },
  {
    id: "brick-breaker",
    title: "Brick Breaker",
    category: "arcade",
    blurb: "Bounce the ball, smash every brick. A neon Breakout classic.",
    image: "https://images.unsplash.com/photo-1698064534597-e039edaa0717?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    type: "single",
    free: true,
  },
  {
    id: "flappy",
    title: "Flappy Block",
    category: "arcade",
    blurb: "Tap to fly, dodge the pipes. One more try… we promise.",
    image: "https://images.unsplash.com/photo-1708099332948-d6d3b06e918c?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    type: "single",
    free: true,
  },
  {
    id: "dino-run",
    title: "Neon Dino Run",
    category: "arcade",
    blurb: "Endless runner. Jump the obstacles and chase the high score.",
    image: "https://images.unsplash.com/photo-1574661569551-8374cd0465e2?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    type: "single",
    free: true,
  },
  {
    id: "bubble-pop",
    title: "Bubble Pop Frenzy",
    category: "arcade",
    blurb: "Pop as many bubbles as you can before the clock runs out.",
    image: "https://images.unsplash.com/photo-1565660761890-0ecd9606690f?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    type: "single",
    free: true,
  },
  {
    id: "minesweeper",
    title: "Minesweeper",
    category: "brain",
    blurb: "Clear the field without hitting a mine. Logic over luck.",
    image: "https://images.pexels.com/photos/10559023/pexels-photo-10559023.jpeg?auto=compress&cs=tinysrgb&w=800",
    type: "single",
    free: true,
  },
  {
    id: "lights-out",
    title: "Lights Out",
    category: "brain",
    blurb: "Turn off every light. Each tap flips a plus-shaped cross.",
    image: "https://images.unsplash.com/photo-1768527858342-037cff722276?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    type: "single",
    free: true,
  },
  {
    id: "digit-memory",
    title: "Digit Memory",
    category: "brain",
    blurb: "Memorize the number, type it back. It grows every round.",
    image: "https://images.unsplash.com/photo-1502570149819-b2260483d302?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    type: "single",
    free: true,
  },
  {
    id: "stroop",
    title: "Stroop Color Test",
    category: "brain",
    blurb: "Match the color of the word, not what it says. Trickier than it sounds!",
    image: "https://images.unsplash.com/photo-1626080308326-a6131ac180db?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    type: "single",
    free: true,
  },
  {
    id: "schulte",
    title: "Schulte Table",
    category: "brain",
    blurb: "Tap 1 to 25 in order as fast as you can. A focus-training classic.",
    image: "https://images.unsplash.com/photo-1505356822725-08ad25f3ffe4?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    type: "single",
    free: true,
  },
  {
    id: "tap-war",
    title: "Tap War",
    category: "arcade",
    blurb: "10-second tapping showdown. Most taps wins — grab a friend!",
    image: "https://images.pexels.com/photos/17255084/pexels-photo-17255084.jpeg?auto=compress&cs=tinysrgb&w=800",
    type: "versus",
    free: true,
  },
  {
    id: "aim-trainer",
    title: "Aim Trainer",
    category: "arcade",
    blurb: "Click the targets as fast as you can. Train your precision.",
    image: "https://images.unsplash.com/photo-1708099332948-d6d3b06e918c?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    type: "single",
    free: true,
  },
  {
    id: "rps",
    title: "Rock Paper Scissors",
    category: "arcade",
    blurb: "First to 5 against the CPU. Classic, quick, addictive.",
    image: "https://images.unsplash.com/photo-1582298538104-fe2e74c27f59?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    type: "casual",
    free: true,
  },
  {
    id: "hangman",
    title: "Gamer Hangman",
    category: "brain",
    blurb: "Guess the gaming word before the figure is complete.",
    image: "https://images.unsplash.com/photo-1632501641765-e568d28b0015?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    type: "single",
    free: true,
  },
  {
    id: "tower-stack",
    title: "Tower Stack",
    category: "arcade",
    blurb: "Drop blocks and stack them sky-high. Precision is everything.",
    image: "https://images.pexels.com/photos/163064/play-stone-network-networked-interactive-163064.jpeg?auto=compress&cs=tinysrgb&w=800",
    type: "single",
    free: true,
  },
  {
    id: "piano-tiles",
    title: "Neon Tiles",
    category: "arcade",
    blurb: "Tap the falling tiles, never miss one. How long can you last?",
    image: "https://images.unsplash.com/photo-1768527858342-037cff722276?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    type: "single",
    free: true,
  },
  {
    id: "memory-grid",
    title: "Memory Grid",
    category: "brain",
    blurb: "Watch the pattern flash, then repeat it. It grows every round.",
    image: "https://images.unsplash.com/photo-1771930629966-3c6fb074bded?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    type: "single",
    free: true,
  },
  {
    id: "reaction-duel",
    title: "Reaction Duel",
    category: "arcade",
    blurb: "2 players, 1 keyboard. When it turns green — smash your key first!",
    image: "https://images.unsplash.com/photo-1511512578047-dfb367046420?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    type: "versus",
    free: true,
  },

  // ---- New batch: standalone games ----
  { id: "click-speed", title: "Click Speed Test", category: "arcade", blurb: "How many clicks can you land in 5 seconds? Measure your CPS.", image: "https://images.unsplash.com/photo-1538113300105-e51e4560b4aa?crop=entropy&cs=srgb&fm=jpg&q=85&w=800", type: "single", free: true },
  { id: "reflex-grid", title: "Reflex Grid", category: "arcade", blurb: "Tap the glowing tile the instant it lights up. Pure reflexes.", image: "https://images.unsplash.com/photo-1511512578047-dfb367046420?crop=entropy&cs=srgb&fm=jpg&q=85&w=800", type: "single", free: true },
  { id: "number-guess", title: "Number Guesser", category: "brain", blurb: "Hi–lo hints guide you to the secret number 1–100. Fewer guesses = more points.", image: "https://images.unsplash.com/photo-1635070041078-e363dbe005cb?crop=entropy&cs=srgb&fm=jpg&q=85&w=800", type: "single", free: true },
  { id: "coin-streak", title: "Coin Flip Streak", category: "arcade", blurb: "Call heads or tails and build the longest streak you can.", image: "https://images.pexels.com/photos/17255084/pexels-photo-17255084.jpeg?auto=compress&cs=tinysrgb&w=800", type: "casual", free: true },
  { id: "balloon-risk", title: "Balloon Risk", category: "arcade", blurb: "Pump for points — but bank before it pops! Push your luck.", image: "https://images.unsplash.com/photo-1565660761890-0ecd9606690f?crop=entropy&cs=srgb&fm=jpg&q=85&w=800", type: "single", free: true },
  { id: "word-scramble", title: "Word Scramble", category: "brain", blurb: "Unscramble as many gaming words as you can in 60 seconds.", image: "https://images.unsplash.com/photo-1632501641765-e568d28b0015?crop=entropy&cs=srgb&fm=jpg&q=85&w=800", type: "single", free: true },
  { id: "dice-duel", title: "Dice Duel", category: "arcade", blurb: "Roll against the CPU. First to 5 wins the match.", image: "https://images.unsplash.com/photo-1582298538104-fe2e74c27f59?crop=entropy&cs=srgb&fm=jpg&q=85&w=800", type: "casual", free: true },
  { id: "spacebar-masher", title: "Spacebar Masher", category: "arcade", blurb: "Mash the bar to the top before time runs out. Finger workout!", image: "https://images.pexels.com/photos/5380584/pexels-photo-5380584.jpeg?auto=compress&cs=tinysrgb&w=800", type: "single", free: true },
  { id: "time-guesser", title: "5-Second Challenge", category: "brain", blurb: "Stop the timer at exactly 5.000s — no clock to help you. Trust your gut.", image: "https://images.unsplash.com/photo-1505356822725-08ad25f3ffe4?crop=entropy&cs=srgb&fm=jpg&q=85&w=800", type: "single", free: true },
  { id: "bullseye", title: "Bullseye Stop", category: "arcade", blurb: "Stop the marker inside the shrinking zone. Nerves of steel required.", image: "https://images.unsplash.com/photo-1708099332948-d6d3b06e918c?crop=entropy&cs=srgb&fm=jpg&q=85&w=800", type: "single", free: true },
  { id: "egg-catch", title: "Egg Catch", category: "arcade", blurb: "Catch the falling eggs, dodge the bombs. Don't drop your lives!", image: "https://images.unsplash.com/photo-1574661569551-8374cd0465e2?crop=entropy&cs=srgb&fm=jpg&q=85&w=800", type: "single", free: true },
  { id: "meteor-dodge", title: "Meteor Dodge", category: "arcade", blurb: "Pilot your ship through an endless meteor shower. Survive as long as you can.", image: "https://images.unsplash.com/photo-1502570149819-b2260483d302?crop=entropy&cs=srgb&fm=jpg&q=85&w=800", type: "single", free: true },
  { id: "sort-numbers", title: "Sort the Numbers", category: "brain", blurb: "Swap tiles to arrange 1–9 in order using the fewest moves.", image: "https://images.pexels.com/photos/163064/play-stone-network-networked-interactive-163064.jpeg?auto=compress&cs=tinysrgb&w=800", type: "single", free: true },
  { id: "hanoi", title: "Tower of Hanoi", category: "brain", blurb: "Move the whole stack to the right peg. A timeless logic puzzle.", image: "https://images.unsplash.com/photo-1768527858342-037cff722276?crop=entropy&cs=srgb&fm=jpg&q=85&w=800", type: "single", free: true },

  // ---- New batch: SpeedChoice rapid-fire games (45s) ----
  { id: "quick-add", title: "Quick Addition", category: "brain", blurb: "Add fast! Solve as many sums as you can in 45 seconds.", image: "https://images.unsplash.com/photo-1635070041078-e363dbe005cb?crop=entropy&cs=srgb&fm=jpg&q=85&w=800", type: "single", free: true },
  { id: "quick-mult", title: "Times Table Blitz", category: "brain", blurb: "A multiplication speed drill. Beat the clock with your times tables.", image: "https://images.unsplash.com/photo-1635070041078-e363dbe005cb?crop=entropy&cs=srgb&fm=jpg&q=85&w=800", type: "single", free: true },
  { id: "math-tf", title: "True or False Math", category: "brain", blurb: "Is the equation right or wrong? Snap-judge it before time's up.", image: "https://images.unsplash.com/photo-1509228468518-180dd4864904?crop=entropy&cs=srgb&fm=jpg&q=85&w=800", type: "single", free: true },
  { id: "bigger-number", title: "Bigger Number", category: "brain", blurb: "Tap the larger number as fast as you can spot it.", image: "https://images.unsplash.com/photo-1509228468518-180dd4864904?crop=entropy&cs=srgb&fm=jpg&q=85&w=800", type: "single", free: true },
  { id: "odd-even", title: "Odd or Even", category: "brain", blurb: "Snap-judge every number: odd or even? Keep the streak going.", image: "https://images.unsplash.com/photo-1635070041078-e363dbe005cb?crop=entropy&cs=srgb&fm=jpg&q=85&w=800", type: "single", free: true },
  { id: "which-prime", title: "Spot the Prime", category: "brain", blurb: "Find the prime number in the lineup, fast.", image: "https://images.unsplash.com/photo-1509228468518-180dd4864904?crop=entropy&cs=srgb&fm=jpg&q=85&w=800", type: "single", free: true },
  { id: "roman-numerals", title: "Roman Numerals", category: "brain", blurb: "Decode the Roman numerals against the clock.", image: "https://images.unsplash.com/photo-1505356822725-08ad25f3ffe4?crop=entropy&cs=srgb&fm=jpg&q=85&w=800", type: "single", free: true },
  { id: "emoji-count", title: "Count the Emojis", category: "arcade", blurb: "Count them at a glance — fast-paced speed counting fun.", image: "https://images.unsplash.com/photo-1565660761890-0ecd9606690f?crop=entropy&cs=srgb&fm=jpg&q=85&w=800", type: "single", free: true },
  { id: "spelling-bee", title: "Speed Spelling Bee", category: "brain", blurb: "Pick the correctly spelled word every round, fast.", image: "https://images.unsplash.com/photo-1632501641765-e568d28b0015?crop=entropy&cs=srgb&fm=jpg&q=85&w=800", type: "single", free: true },
  { id: "capital-quiz", title: "Capital Cities Blitz", category: "brain", blurb: "Name the capital city as fast as you can. Geography speed test.", image: "https://images.unsplash.com/photo-1502920917128-1aa500764cbd?crop=entropy&cs=srgb&fm=jpg&q=85&w=800", type: "single", free: true },
  { id: "synonym-match", title: "Synonym Match", category: "brain", blurb: "Pick the matching synonym before time runs out.", image: "https://images.unsplash.com/photo-1632501641765-e568d28b0015?crop=entropy&cs=srgb&fm=jpg&q=85&w=800", type: "single", free: true },
  { id: "bigger-fraction", title: "Bigger Fraction", category: "brain", blurb: "Which fraction is larger? Think quick and tap.", image: "https://images.unsplash.com/photo-1509228468518-180dd4864904?crop=entropy&cs=srgb&fm=jpg&q=85&w=800", type: "single", free: true },
  { id: "count-vowels", title: "Count the Vowels", category: "brain", blurb: "How many vowels in the word? Snap your answer.", image: "https://images.unsplash.com/photo-1632501641765-e568d28b0015?crop=entropy&cs=srgb&fm=jpg&q=85&w=800", type: "single", free: true },
  { id: "order-ops", title: "Order of Operations", category: "brain", blurb: "Solve it with PEMDAS — fast and clean.", image: "https://images.unsplash.com/photo-1635070041078-e363dbe005cb?crop=entropy&cs=srgb&fm=jpg&q=85&w=800", type: "single", free: true },
  { id: "color-id", title: "Name That Color", category: "arcade", blurb: "Tap the color you SEE — quick eyes win.", image: "https://images.unsplash.com/photo-1626080308326-a6131ac180db?crop=entropy&cs=srgb&fm=jpg&q=85&w=800", type: "single", free: true },
  { id: "double-it", title: "Double Trouble", category: "arcade", blurb: "Double the number as fast as you can.", image: "https://images.unsplash.com/photo-1635070041078-e363dbe005cb?crop=entropy&cs=srgb&fm=jpg&q=85&w=800", type: "single", free: true },
];

export const gameById = (id) => GAMES.find((g) => g.id === id);
export const gamesByCategory = (cat) => GAMES.filter((g) => g.category === cat);

// ---------------- BuzzFeed-style quizzes ----------------
export const QUIZZES = [
  {
    id: "gamer-type",
    title: "What Kind of Gamer Are You?",
    category: "quiz",
    tag: "Personality",
    blurb: "Answer 5 questions and reveal your true gamer soul.",
    image: "https://images.unsplash.com/photo-1511988617509-a57c8a288659?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    type: "quiz",
    free: true,
    questions: [
      {
        q: "Pick a weekend vibe:",
        options: [
          { text: "Speedrunning everything", type: "A" },
          { text: "Building a cozy base", type: "B" },
          { text: "Outsmarting opponents", type: "C" },
          { text: "Exploring a huge open world", type: "D" },
        ],
      },
      {
        q: "Your snack of choice mid-game:",
        options: [
          { text: "Energy drink, obviously", type: "A" },
          { text: "Tea and cookies", type: "B" },
          { text: "Whatever, I'm focused", type: "C" },
          { text: "A full charcuterie board", type: "D" },
        ],
      },
      {
        q: "A new game drops. You:",
        options: [
          { text: "Rush to top the leaderboard", type: "A" },
          { text: "Read every bit of lore", type: "B" },
          { text: "Study the meta first", type: "C" },
          { text: "Wander off the main path", type: "D" },
        ],
      },
      {
        q: "Pick a power:",
        options: [
          { text: "Super speed", type: "A" },
          { text: "Infinite crafting", type: "B" },
          { text: "Read minds", type: "C" },
          { text: "Teleport anywhere", type: "D" },
        ],
      },
      {
        q: "Your ideal teammate is:",
        options: [
          { text: "Aggressive and fast", type: "A" },
          { text: "Supportive and chill", type: "B" },
          { text: "A tactical genius", type: "C" },
          { text: "Down for anything", type: "D" },
        ],
      },
    ],
    results: {
      A: { title: "The Speed Demon", desc: "You live for adrenaline, leaderboards, and that perfect run. Slowing down is not in your vocabulary." },
      B: { title: "The Cozy Architect", desc: "You build, nurture, and create. Games are your peaceful kingdom — and you rule it gently." },
      C: { title: "The Mastermind", desc: "Every move is calculated. You don't just play games, you solve them. The meta bows to you." },
      D: { title: "The Free Spirit", desc: "Rules? Maps? Boring. You're here for the adventure, the secrets, and the vibes." },
    },
  },
  {
    id: "spirit-arcade",
    title: "Which Arcade Machine Are You?",
    category: "quiz",
    tag: "Personality",
    blurb: "Discover your inner cabinet. Insert coin to begin.",
    image: "https://images.unsplash.com/photo-1542751371-adc38448a05e?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    type: "quiz",
    free: true,
    questions: [
      {
        q: "Your friends describe you as:",
        options: [
          { text: "Loud and competitive", type: "A" },
          { text: "Clever and quick", type: "B" },
          { text: "Calm and steady", type: "C" },
          { text: "Unpredictable", type: "D" },
        ],
      },
      {
        q: "Pick a color that screams YOU:",
        options: [
          { text: "Hot magenta", type: "A" },
          { text: "Electric cyan", type: "B" },
          { text: "Toxic lime", type: "C" },
          { text: "Voltage yellow", type: "D" },
        ],
      },
      {
        q: "How do you win an argument?",
        options: [
          { text: "Overwhelming energy", type: "A" },
          { text: "Pure logic", type: "B" },
          { text: "Patience", type: "C" },
          { text: "A wildcard twist", type: "D" },
        ],
      },
      {
        q: "Choose a battle cry:",
        options: [
          { text: "LET'S GOOO!", type: "A" },
          { text: "Calculated.", type: "B" },
          { text: "Slow and sure.", type: "C" },
          { text: "Chaos reigns!", type: "D" },
        ],
      },
    ],
    results: {
      A: { title: "Fighting Cabinet", desc: "All energy, all hype. You bring the noise and the crowd gathers around you." },
      B: { title: "Puzzle Machine", desc: "Sleek and smart. You make winning look effortless and elegant." },
      C: { title: "Pinball Table", desc: "Steady, satisfying, endlessly replayable. People keep coming back to you." },
      D: { title: "Claw Machine", desc: "Mysterious and a little chaotic — but oh-so addictive." },
    },
  },
  {
    id: "love-language",
    title: "What's Your Love Language?",
    category: "quiz",
    tag: "Relationship",
    blurb: "Discover how you give and crave love. Answer honestly!",
    image: "https://images.unsplash.com/photo-1540076156429-35ffe82b7870?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    type: "quiz",
    free: true,
    questions: [
      { q: "What makes you feel most loved?", options: [
        { text: "Hearing 'I love you' and compliments", type: "A" },
        { text: "A long, warm hug", type: "B" },
        { text: "A thoughtful little gift", type: "C" },
        { text: "Someone helping me out", type: "D" } ] },
      { q: "On a perfect date, you want…", options: [
        { text: "Deep, sweet conversation", type: "A" },
        { text: "To cuddle on the couch", type: "B" },
        { text: "A surprise present", type: "C" },
        { text: "Them to plan everything", type: "D" } ] },
      { q: "Your partner is stressed. You…", options: [
        { text: "Tell them how amazing they are", type: "A" },
        { text: "Hold their hand", type: "B" },
        { text: "Bring their favorite snack", type: "C" },
        { text: "Do their chores for them", type: "D" } ] },
      { q: "What hurts the most?", options: [
        { text: "Harsh words", type: "A" },
        { text: "No physical affection", type: "B" },
        { text: "Forgotten occasions", type: "C" },
        { text: "Feeling unsupported", type: "D" } ] },
      { q: "You show love by…", options: [
        { text: "Saying sweet things", type: "A" },
        { text: "Being close and touchy", type: "B" },
        { text: "Giving gifts", type: "C" },
        { text: "Doing favors", type: "D" } ] },
    ],
    results: {
      A: { title: "Words of Affirmation", desc: "Sweet nothings are everything to you. You feel most loved when it's spoken out loud — and you give that gift right back." },
      B: { title: "Physical Touch", desc: "A hug speaks louder than a paragraph. Closeness and warmth are how your heart connects." },
      C: { title: "Receiving Gifts", desc: "It's never about the price — it's the thought. A small surprise tells you that you were on someone's mind." },
      D: { title: "Acts of Service", desc: "Actions over words, always. When someone shows up and helps, your heart melts." },
    },
  },
  {
    id: "relationship-ready",
    title: "Are You Ready for a Relationship?",
    category: "quiz",
    tag: "Relationship",
    blurb: "Single, mingling, or somewhere in between? Find out.",
    image: "https://images.unsplash.com/photo-1591969851586-adbbd4accf81?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    type: "quiz",
    free: true,
    questions: [
      { q: "Thinking about dating makes you feel…", options: [
        { text: "Excited and ready!", type: "A" },
        { text: "Curious but cautious", type: "B" },
        { text: "Kinda meh right now", type: "C" },
        { text: "Anxious, honestly", type: "D" } ] },
      { q: "Your free time is mostly…", options: [
        { text: "Open for someone special", type: "A" },
        { text: "Balanced with hobbies", type: "B" },
        { text: "Packed with my own goals", type: "C" },
        { text: "Recovering from life", type: "D" } ] },
      { q: "Past relationships feel…", options: [
        { text: "Fully healed, lessons learned", type: "A" },
        { text: "Mostly processed", type: "B" },
        { text: "Not on my mind", type: "C" },
        { text: "Still a bit raw", type: "D" } ] },
      { q: "Compromise sounds…", options: [
        { text: "Natural, I'm a team player", type: "A" },
        { text: "Fine within reason", type: "B" },
        { text: "Hard, I like my way", type: "C" },
        { text: "Exhausting", type: "D" } ] },
    ],
    results: {
      A: { title: "100% Ready for Love", desc: "You're emotionally available, open, and excited. Swipe right on life — your person is out there and you're ready to meet them." },
      B: { title: "Ready, With Standards", desc: "You're open but not desperate. You know what you want and you're willing to wait for the right match. Healthy!" },
      C: { title: "Happily Independent", desc: "Right now your focus is YOU — and that's powerful. Love can wait until it fits into the life you're building." },
      D: { title: "Heal First, Love Later", desc: "Be gentle with yourself. A little self-care and time will get you ready. No rush — your heart deserves it." },
    },
  },
  {
    id: "crush-vibes",
    title: "Does Your Crush Like You Back?",
    category: "quiz",
    tag: "Relationship",
    blurb: "The age-old question, finally answered (for fun!).",
    image: "https://images.unsplash.com/photo-1545920281-8f9385c1b875?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    type: "quiz",
    free: true,
    questions: [
      { q: "How often do they text first?", options: [
        { text: "All the time!", type: "A" },
        { text: "Pretty often", type: "B" },
        { text: "Only when I do", type: "C" },
        { text: "Almost never", type: "D" } ] },
      { q: "When you're together they…", options: [
        { text: "Find reasons to be close", type: "A" },
        { text: "Laugh at everything I say", type: "B" },
        { text: "Act normal and friendly", type: "C" },
        { text: "Seem a bit distant", type: "D" } ] },
      { q: "Do they remember small details about you?", options: [
        { text: "Everything, it's spooky", type: "A" },
        { text: "The big stuff", type: "B" },
        { text: "Sometimes", type: "C" },
        { text: "Not really", type: "D" } ] },
      { q: "Their friends around you are…", options: [
        { text: "Smirking like they know something", type: "A" },
        { text: "Friendly and curious", type: "B" },
        { text: "Just chill", type: "C" },
        { text: "I haven't met them", type: "D" } ] },
    ],
    results: {
      A: { title: "They're Totally Into You! 💘", desc: "The signs are LOUD. Shoot your shot — the odds look very, very good." },
      B: { title: "Strong Maybe 😏", desc: "There's real chemistry brewing. A little more time (or courage) could tip this into something." },
      C: { title: "Friend Zone… For Now", desc: "Right now it reads as friendly. Build the connection and see if the spark grows." },
      D: { title: "Keep Your Options Open", desc: "The vibes are unclear. Don't put all your hope here — you're a catch with plenty of options!" },
    },
  },
  {
    id: "anime-hero",
    title: "Which Anime Hero Are You?",
    category: "quiz",
    tag: "Anime",
    blurb: "Unleash your inner protagonist. Power up!",
    image: "https://images.unsplash.com/photo-1727409048076-182d2907a59e?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    type: "quiz",
    free: true,
    questions: [
      { q: "Your dream is to…", options: [
        { text: "Be the very best, no matter what", type: "A" },
        { text: "Protect everyone I love", type: "B" },
        { text: "Uncover the truth", type: "C" },
        { text: "Have epic adventures", type: "D" } ] },
      { q: "In a fight you rely on…", options: [
        { text: "Raw determination", type: "A" },
        { text: "Sheer power", type: "B" },
        { text: "Strategy and intellect", type: "C" },
        { text: "Quick instincts", type: "D" } ] },
      { q: "Your friends say you're…", options: [
        { text: "Never giving up", type: "A" },
        { text: "Fiercely loyal", type: "B" },
        { text: "The clever one", type: "C" },
        { text: "Free-spirited", type: "D" } ] },
      { q: "Pick a signature look:", options: [
        { text: "Bright and bold", type: "A" },
        { text: "Strong and stoic", type: "B" },
        { text: "Sharp and mysterious", type: "C" },
        { text: "Casual and cool", type: "D" } ] },
    ],
    results: {
      A: { title: "The Determined Underdog", desc: "Loud, relentless, and impossible to keep down. You turn 'impossible' into 'watch me'. Believe it!" },
      B: { title: "The Powerhouse Guardian", desc: "Strength with a heart of gold. You'd take any hit to protect the people you love." },
      C: { title: "The Genius Strategist", desc: "Five steps ahead, always. You win battles in your mind before they even start." },
      D: { title: "The Free-Spirited Wanderer", desc: "The world is your playground. You chase adventure, freedom, and the next horizon." },
    },
  },
  {
    id: "anime-power",
    title: "What's Your Anime Superpower?",
    category: "quiz",
    tag: "Anime",
    blurb: "If you were in an anime, what ability would you wield?",
    image: "https://images.unsplash.com/photo-1717185891319-6bf096fba62f?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    type: "quiz",
    free: true,
    questions: [
      { q: "Pick an element:", options: [
        { text: "Fire 🔥", type: "A" },
        { text: "Lightning ⚡", type: "B" },
        { text: "Shadow 🌑", type: "C" },
        { text: "Ice ❄️", type: "D" } ] },
      { q: "Your battle style is…", options: [
        { text: "All-out offense", type: "A" },
        { text: "Blinding speed", type: "B" },
        { text: "Sneaky and clever", type: "C" },
        { text: "Calm control", type: "D" } ] },
      { q: "Choose a vibe:", options: [
        { text: "Passionate", type: "A" },
        { text: "Energetic", type: "B" },
        { text: "Mysterious", type: "C" },
        { text: "Cool-headed", type: "D" } ] },
      { q: "Your weakness is…", options: [
        { text: "Acting before thinking", type: "A" },
        { text: "Impatience", type: "B" },
        { text: "Trusting no one", type: "C" },
        { text: "Overthinking", type: "D" } ] },
    ],
    results: {
      A: { title: "Flame Manipulation", desc: "You burn with passion and fight with everything you've got. Where you go, sparks fly." },
      B: { title: "Lightning Speed", desc: "Too fast to catch, too bright to ignore. You strike before anyone sees it coming." },
      C: { title: "Shadow Control", desc: "Master of the unseen. You move through the dark and bend it to your will." },
      D: { title: "Ice & Time Control", desc: "Cool, precise, unstoppable. You freeze the chaos and command the moment." },
    },
  },
  {
    id: "anime-binge",
    title: "What Anime Should You Binge Next?",
    category: "quiz",
    tag: "Anime",
    blurb: "Out of things to watch? Let us pick your next obsession.",
    image: "https://images.pexels.com/photos/31121727/pexels-photo-31121727.jpeg?auto=compress&cs=tinysrgb&w=800",
    type: "quiz",
    free: true,
    questions: [
      { q: "What mood are you in?", options: [
        { text: "Hype and action!", type: "A" },
        { text: "Feels and tears", type: "B" },
        { text: "Laughs and chaos", type: "C" },
        { text: "Mystery and tension", type: "D" } ] },
      { q: "Ideal episode length binge?", options: [
        { text: "Give me 100+ episodes", type: "A" },
        { text: "A tight emotional arc", type: "B" },
        { text: "Easy, fun, rewatchable", type: "C" },
        { text: "Mind-bending and short", type: "D" } ] },
      { q: "Pick a setting:", options: [
        { text: "Epic battle world", type: "A" },
        { text: "Slice of life town", type: "B" },
        { text: "Goofy high school", type: "C" },
        { text: "Dark dystopia", type: "D" } ] },
    ],
    results: {
      A: { title: "Go Watch: A Shonen Epic", desc: "You need big fights, rivals, and 'never give up' energy. Queue up a legendary battle shonen and get hyped." },
      B: { title: "Go Watch: A Tearjerker Drama", desc: "You're craving the feels. Pick an emotional gut-punch of a series and keep tissues nearby." },
      C: { title: "Go Watch: A Comedy Gem", desc: "You want laughs and good vibes. A chaotic comedy or slice-of-life will be your comfort binge." },
      D: { title: "Go Watch: A Psychological Thriller", desc: "You love a mind game. Dive into a dark, twisty thriller that'll keep you guessing." },
    },
  },
  {
    id: "vg-hero",
    title: "Which Video Game Hero Are You?",
    category: "quiz",
    tag: "Personality",
    blurb: "Plumber, hunter, hero of time? Find your legend.",
    image: "https://images.unsplash.com/photo-1542751371-adc38448a05e?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    type: "quiz",
    free: true,
    questions: [
      { q: "Your approach to problems:", options: [
        { text: "Jump right in", type: "A" },
        { text: "Gear up and explore", type: "B" },
        { text: "Solve the puzzle", type: "C" },
        { text: "Outgun everything", type: "D" } ] },
      { q: "Pick a sidekick:", options: [
        { text: "A loyal little buddy", type: "A" },
        { text: "A trusty companion", type: "B" },
        { text: "A wise guide", type: "C" },
        { text: "A heavy weapon", type: "D" } ] },
      { q: "Your motto:", options: [
        { text: "Let's-a go!", type: "A" },
        { text: "Adventure awaits", type: "B" },
        { text: "Knowledge is power", type: "C" },
        { text: "Stay frosty", type: "D" } ] },
    ],
    results: {
      A: { title: "The Cheerful Champion", desc: "Optimistic, brave, and always ready to leap into action. You make saving the day look fun." },
      B: { title: "The Bold Explorer", desc: "Curious and courageous. You live for the unknown and the thrill of discovery." },
      C: { title: "The Clever Hero of Legend", desc: "Calm, wise, and resourceful. You solve what others can't and rise to every challenge." },
      D: { title: "The Fearless Warrior", desc: "Tough as nails and unstoppable. When things get hard, you get going." },
    },
  },
  {
    id: "iq-personality",
    title: "What's Your Thinking Style? (IQ Edition)",
    category: "quiz",
    tag: "IQ",
    blurb: "Logical, creative, or street-smart? Discover your brain type.",
    image: "https://images.unsplash.com/photo-1509228468518-180dd4864904?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    type: "quiz",
    free: true,
    questions: [
      { q: "You solve problems by…", options: [
        { text: "Breaking them into logical steps", type: "A" },
        { text: "Imagining wild new ideas", type: "B" },
        { text: "Reading people and situations", type: "C" },
        { text: "Trusting gut experience", type: "D" } ] },
      { q: "Which puzzle excites you?", options: [
        { text: "A tricky math riddle", type: "A" },
        { text: "An open-ended design", type: "B" },
        { text: "A negotiation", type: "C" },
        { text: "A real-world fix-it", type: "D" } ] },
      { q: "People come to you for…", options: [
        { text: "Sharp analysis", type: "A" },
        { text: "Fresh creativity", type: "B" },
        { text: "Emotional wisdom", type: "C" },
        { text: "Practical advice", type: "D" } ] },
      { q: "Your superpower is…", options: [
        { text: "Logic", type: "A" },
        { text: "Imagination", type: "B" },
        { text: "Empathy", type: "C" },
        { text: "Common sense", type: "D" } ] },
    ],
    results: {
      A: { title: "Logical-Mathematical Mind", desc: "You think in patterns, systems, and proofs. Give you a problem and you'll engineer the cleanest solution." },
      B: { title: "Creative Genius", desc: "Your brain colors outside the lines. You see possibilities others can't even imagine." },
      C: { title: "Emotional Intelligence", desc: "You read the room like a book. Your smarts are social — and that's a rare superpower." },
      D: { title: "Practical Street-Smarts", desc: "Book smarts are nice, but you've got the real-world wisdom that actually gets things done." },
    },
  },
  {
    id: "soulmate-color",
    title: "What Color Is Your Soulmate's Aura?",
    category: "quiz", tag: "Relationship",
    blurb: "Your perfect match has a color. Let's reveal it.",
    image: "https://images.unsplash.com/photo-1545920281-8f9385c1b875?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    type: "quiz", free: true,
    questions: [
      { q: "Your ideal date is…", options: [
        { text: "A cozy night in", type: "A" }, { text: "A wild adventure", type: "B" },
        { text: "Deep conversation over coffee", type: "C" }, { text: "Dancing till sunrise", type: "D" } ] },
      { q: "You fall for someone who is…", options: [
        { text: "Kind and gentle", type: "A" }, { text: "Bold and exciting", type: "B" },
        { text: "Smart and curious", type: "C" }, { text: "Fun and spontaneous", type: "D" } ] },
      { q: "Pick a season:", options: [
        { text: "Autumn", type: "A" }, { text: "Summer", type: "B" }, { text: "Winter", type: "C" }, { text: "Spring", type: "D" } ] },
    ],
    results: {
      A: { title: "Warm Rose 🌹", desc: "Your soulmate radiates comfort and tenderness — the person who makes anywhere feel like home." },
      B: { title: "Electric Red ⚡", desc: "Your match is passionate and daring, the spark that turns your life into an adventure." },
      C: { title: "Deep Indigo 🔮", desc: "Your person is thoughtful and soulful — the mind that meets yours on every level." },
      D: { title: "Sunny Gold ☀️", desc: "Your soulmate is pure joy and energy, the one who keeps every day bright and playful." },
    },
  },
  {
    id: "dating-red-flag",
    title: "What's Your Dating Red Flag?",
    category: "quiz", tag: "Relationship",
    blurb: "We've all got one. Find out yours (be honest!).",
    image: "https://images.unsplash.com/photo-1540076156429-35ffe82b7870?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    type: "quiz", free: true,
    questions: [
      { q: "How fast do you text back?", options: [
        { text: "Instantly, every time", type: "A" }, { text: "When I feel like it", type: "B" },
        { text: "I overthink every word", type: "C" }, { text: "Three days later", type: "D" } ] },
      { q: "After a great first date you…", options: [
        { text: "Plan our wedding", type: "A" }, { text: "Keep my options open", type: "B" },
        { text: "Assume they hate me", type: "C" }, { text: "Forget to follow up", type: "D" } ] },
      { q: "Arguments make you…", options: [
        { text: "Cling harder", type: "A" }, { text: "Go cold", type: "B" },
        { text: "Spiral with worry", type: "C" }, { text: "Ghost", type: "D" } ] },
    ],
    results: {
      A: { title: "Moving Too Fast 🚀", desc: "Your heart's in the right place, but pump the brakes! Let things breathe — the good ones won't run." },
      B: { title: "Emotionally Unavailable 🧊", desc: "You guard your heart hard. A little vulnerability could unlock something amazing." },
      C: { title: "The Overthinker 🌀", desc: "You write entire dramas in your head. Trust more, assume less — you're more loved than you think." },
      D: { title: "The Ghoster 👻", desc: "Disappearing is your escape hatch. A simple honest text beats vanishing every time." },
    },
  },
  {
    id: "anime-villain",
    title: "Which Anime Villain Are You?",
    category: "quiz", tag: "Anime",
    blurb: "Even the bad guys have main-character energy. Embrace it.",
    image: "https://images.unsplash.com/photo-1717185891319-6bf096fba62f?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    type: "quiz", free: true,
    questions: [
      { q: "Your master plan is driven by…", options: [
        { text: "Revenge", type: "A" }, { text: "Power", type: "B" },
        { text: "A twisted ideal", type: "C" }, { text: "Pure chaos", type: "D" } ] },
      { q: "Your vibe in one word:", options: [
        { text: "Tragic", type: "A" }, { text: "Commanding", type: "B" },
        { text: "Calculating", type: "C" }, { text: "Unhinged", type: "D" } ] },
      { q: "Your weakness is…", options: [
        { text: "My past", type: "A" }, { text: "My ego", type: "B" },
        { text: "My obsession", type: "C" }, { text: "My recklessness", type: "D" } ] },
    ],
    results: {
      A: { title: "The Tragic Antagonist", desc: "You were wronged once and never forgot. Sympathetic, complex, and unforgettable — the villain fans secretly root for." },
      B: { title: "The Overlord", desc: "Domination is the goal and you make it look effortless. Born to rule, you command every room you enter." },
      C: { title: "The Mastermind", desc: "Coldly brilliant and ten steps ahead. You believe the ends justify the means — every move is a chess play." },
      D: { title: "The Agent of Chaos", desc: "No plan, just vibes and destruction. Wildly unpredictable and impossible to look away from." },
    },
  },
  {
    id: "anime-world",
    title: "Which Anime World Would You Live In?",
    category: "quiz", tag: "Anime",
    blurb: "Pack your bags — your perfect anime universe awaits.",
    image: "https://images.pexels.com/photos/31121727/pexels-photo-31121727.jpeg?auto=compress&cs=tinysrgb&w=800",
    type: "quiz", free: true,
    questions: [
      { q: "Your dream lifestyle:", options: [
        { text: "Epic battles & training arcs", type: "A" }, { text: "Magic and wonder", type: "B" },
        { text: "Peaceful small-town life", type: "C" }, { text: "High-tech future city", type: "D" } ] },
      { q: "Pick a companion:", options: [
        { text: "A rival turned friend", type: "A" }, { text: "A magical creature", type: "B" },
        { text: "Close-knit neighbors", type: "C" }, { text: "An AI sidekick", type: "D" } ] },
      { q: "Your ideal power source:", options: [
        { text: "Inner strength", type: "A" }, { text: "Ancient spells", type: "B" },
        { text: "Good food & rest", type: "C" }, { text: "Cybernetics", type: "D" } ] },
    ],
    results: {
      A: { title: "A Shonen Battle World", desc: "You'd thrive where strength and willpower decide everything. Rivals, training, and glory await." },
      B: { title: "A Magical Fantasy Realm", desc: "Spells, spirits, and sweeping landscapes — you belong in a world where wonder is real." },
      C: { title: "A Cozy Slice-of-Life Town", desc: "Gentle days, warm friends, great food. Your soul wants peace, comfort, and quiet joy." },
      D: { title: "A Cyberpunk Megacity", desc: "Neon, tech, and edge. You'd live large in a glittering future full of possibility." },
    },
  },
  {
    id: "anime-soulmate",
    title: "Who's Your Anime Soulmate Type?",
    category: "quiz", tag: "Anime",
    blurb: "Tsundere? Cinnamon roll? Find your fated anime love.",
    image: "https://images.unsplash.com/photo-1727409048076-182d2907a59e?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    type: "quiz", free: true,
    questions: [
      { q: "You're attracted to someone who…", options: [
        { text: "Acts tough but is soft inside", type: "A" }, { text: "Is sweet and pure", type: "B" },
        { text: "Is mysterious and cool", type: "C" }, { text: "Is loud and full of life", type: "D" } ] },
      { q: "Your love language:", options: [
        { text: "Playful teasing", type: "A" }, { text: "Gentle care", type: "B" },
        { text: "Quiet loyalty", type: "C" }, { text: "Big adventures", type: "D" } ] },
      { q: "First date energy:", options: [
        { text: "Banter and blushing", type: "A" }, { text: "Soft and shy", type: "B" },
        { text: "Cool and composed", type: "C" }, { text: "Chaotic fun", type: "D" } ] },
    ],
    results: {
      A: { title: "The Tsundere 💢", desc: "Your soulmate hides a giant heart behind a prickly attitude. The push-pull is half the fun for you." },
      B: { title: "The Cinnamon Roll 🥺", desc: "Pure, kind, and wholesome — your match is the sweetest soul who makes you want to protect them forever." },
      C: { title: "The Cool Mysterious One 🖤", desc: "Calm, loyal, and a little enigmatic. You're drawn to depth and quiet devotion." },
      D: { title: "The Genki Sunshine ☀️", desc: "Endless energy and a contagious laugh. Your perfect match turns every day into an adventure." },
    },
  },
  {
    id: "spirit-animal",
    title: "What's Your Spirit Animal?",
    category: "quiz", tag: "Personality",
    blurb: "The animal that matches your true vibe, revealed.",
    image: "https://images.unsplash.com/photo-1582298538104-fe2e74c27f59?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    type: "quiz", free: true,
    questions: [
      { q: "At a party you're…", options: [
        { text: "The center of attention", type: "A" }, { text: "Observing quietly", type: "B" },
        { text: "Making everyone laugh", type: "C" }, { text: "Deep in one-on-one chats", type: "D" } ] },
      { q: "Your energy is…", options: [
        { text: "Bold and fearless", type: "A" }, { text: "Calm and wise", type: "B" },
        { text: "Playful and clever", type: "C" }, { text: "Loyal and warm", type: "D" } ] },
      { q: "Your ideal day:", options: [
        { text: "Leading the pack", type: "A" }, { text: "Alone in nature", type: "B" },
        { text: "Trying something new", type: "C" }, { text: "With my closest people", type: "D" } ] },
    ],
    results: {
      A: { title: "The Lion 🦁", desc: "Bold, confident, and a natural leader. You walk in like you own the place — because you kind of do." },
      B: { title: "The Owl 🦉", desc: "Wise, observant, and calm. You see what others miss and speak only when it matters." },
      C: { title: "The Fox 🦊", desc: "Clever, playful, and quick-witted. You charm your way through life with style and a grin." },
      D: { title: "The Wolf 🐺", desc: "Fiercely loyal and warm-hearted. Your pack is everything, and you'd do anything for them." },
    },
  },
  {
    id: "which-emoji",
    title: "Which Emoji Matches Your Soul?",
    category: "quiz", tag: "Personality",
    blurb: "You're basically one emoji. Which one? Let's find out.",
    image: "https://images.unsplash.com/photo-1565660761890-0ecd9606690f?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    type: "quiz", free: true,
    questions: [
      { q: "Your default mood:", options: [
        { text: "Happy and chill", type: "A" }, { text: "Dramatic", type: "B" },
        { text: "Cool and unbothered", type: "C" }, { text: "Soft and emotional", type: "D" } ] },
      { q: "In group chats you're…", options: [
        { text: "The hype friend", type: "A" }, { text: "The chaos", type: "B" },
        { text: "The dry one-liner", type: "C" }, { text: "The supportive one", type: "D" } ] },
      { q: "Pick a reaction:", options: [
        { text: "😎", type: "A" }, { text: "💀", type: "B" }, { text: "🙄", type: "C" }, { text: "🥹", type: "D" } ] },
    ],
    results: {
      A: { title: "You're 😎", desc: "Effortlessly cool and positive. You bring the good vibes and somehow always look like you've got it handled." },
      B: { title: "You're 💀", desc: "Chaotic, hilarious, and a little unhinged (affectionate). Life is a comedy and you're the lead." },
      C: { title: "You're 🙄", desc: "Sarcastic royalty. Your dry wit is unmatched and your eye-rolls could win awards." },
      D: { title: "You're 🥹", desc: "Big heart, big feelings. You feel everything deeply and love your people fiercely." },
    },
  },
  {
    id: "pizza-personality",
    title: "What Does Your Pizza Order Say About You?",
    category: "quiz", tag: "Personality",
    blurb: "Your toppings reveal more than you'd think…",
    image: "https://images.unsplash.com/photo-1513104890138-7c749659a591?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    type: "quiz", free: true,
    questions: [
      { q: "Pick your crust:", options: [
        { text: "Classic thin", type: "A" }, { text: "Loaded deep dish", type: "B" },
        { text: "Whatever's fastest", type: "C" }, { text: "Something fancy", type: "D" } ] },
      { q: "Your topping move:", options: [
        { text: "Plain cheese, perfection", type: "A" }, { text: "ALL the toppings", type: "B" },
        { text: "Pepperoni, no notes", type: "C" }, { text: "Pineapple (fight me)", type: "D" } ] },
      { q: "Last slice situation:", options: [
        { text: "I offer it politely", type: "A" }, { text: "I take it, obviously", type: "B" },
        { text: "We split it", type: "C" }, { text: "I already ordered more", type: "D" } ] },
    ],
    results: {
      A: { title: "The Classic Soul", desc: "Reliable, timeless, and quietly confident. You don't need flash — you ARE the standard." },
      B: { title: "The Maximalist", desc: "More is more! You live big, love hard, and never do anything halfway." },
      C: { title: "The Easygoing One", desc: "Low drama, high loyalty. You're the friend everyone wishes they had — chill and dependable." },
      D: { title: "The Bold Original", desc: "You break the rules and own your weird. Trendsetter energy, zero apologies." },
    },
  },
  {
    id: "brain-dominance",
    title: "Are You Left or Right Brained?",
    category: "quiz", tag: "IQ",
    blurb: "Logical analyst or creative dreamer? Discover your brain type.",
    image: "https://images.unsplash.com/photo-1509228468518-180dd4864904?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    type: "quiz", free: true,
    questions: [
      { q: "You make decisions with…", options: [
        { text: "Logic and facts", type: "A" }, { text: "Gut and feeling", type: "B" },
        { text: "A pros/cons list", type: "A" }, { text: "Whatever feels right", type: "B" } ] },
      { q: "Your desk is…", options: [
        { text: "Neat and organized", type: "A" }, { text: "Creative chaos", type: "B" },
        { text: "Color-coded", type: "A" }, { text: "Covered in ideas", type: "B" } ] },
      { q: "You're better at…", options: [
        { text: "Math & analysis", type: "A" }, { text: "Art & imagination", type: "B" },
        { text: "Planning", type: "A" }, { text: "Improvising", type: "B" } ] },
    ],
    results: {
      A: { title: "Left-Brained Analyst 🧮", desc: "Logical, structured, and detail-oriented. You think in systems and solve problems like a pro." },
      B: { title: "Right-Brained Creative 🎨", desc: "Imaginative, intuitive, and free-flowing. You see the world in color and ideas others can't picture." },
    },
  },
  {
    id: "which-decade",
    title: "Which Decade Do You Actually Belong In?",
    category: "quiz", tag: "Personality",
    blurb: "Your soul has a timestamp. Let's find your era.",
    image: "https://images.unsplash.com/photo-1574661569551-8374cd0465e2?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    type: "quiz", free: true,
    questions: [
      { q: "Pick a vibe:", options: [
        { text: "Disco & freedom", type: "A" }, { text: "Neon & synth", type: "B" },
        { text: "Grunge & rebellion", type: "C" }, { text: "Internet & chaos", type: "D" } ] },
      { q: "Your ideal night out:", options: [
        { text: "Roller disco", type: "A" }, { text: "Arcade & mall", type: "B" },
        { text: "A garage band gig", type: "C" }, { text: "Viral meme energy", type: "D" } ] },
      { q: "Your fashion is…", options: [
        { text: "Bold & flared", type: "A" }, { text: "Bright & big-hair", type: "B" },
        { text: "Flannel & combat boots", type: "C" }, { text: "Whatever's trending online", type: "D" } ] },
    ],
    results: {
      A: { title: "The Groovy '70s", desc: "Free spirit, big heart, and a love of good vibes. You'd have ruled the disco floor." },
      B: { title: "The Neon '80s", desc: "Bold, electric, and unforgettable. Synth-pop and arcades are basically your soul's home." },
      C: { title: "The Rebellious '90s", desc: "Effortlessly cool with an anti-establishment streak. You'd be the heart of the indie scene." },
      D: { title: "The Chaotic 2020s", desc: "You're exactly where you belong — chronically online, endlessly creative, and one-of-a-kind." },
    },
  },
];

export const quizById = (id) => QUIZZES.find((q) => q.id === id);

export const ALL_PLAYABLE = [...GAMES, ...QUIZZES];
